import React, {useState} from "react";
import {API} from "../../api-service"
import {useCookies} from 'react-cookie';
import Button from "react-bootstrap/Button";
import example from "./ExcelExample.png"


export default function CSVUpload () {
  const [token] = useCookies(['pn-token']);
  const [file, setFile] = useState();
  const [submit, setSubmit] = useState(false)
  const [badfile, setBadFile] = useState(false)

  const fileChanged = evt => {
    evt.preventDefault();
		setFile(evt.target.files[0]);
    console.log(evt.target.files[0])
	};

	const handleSubmit = evt => {
    evt.preventDefault();
    setBadFile(false);
    const formData = new FormData();
		formData.append('file', file);
    API.uploadCases(formData, token["pn-token"])
    .then(resp => {resp.status == 200? setSubmit(true): setBadFile(true)})
    .catch(error => console.log(error));
	};

  return ( 
    <>
      {submit?
        <p>Success!</p>:
        <form onSubmit={handleSubmit} style={{padding:'10px 10px 10px 0px'}}>
          <p>Please make sure the file is in csv UTF-8 format. <a href={example} target="_blank">Click this link</a> for an example of the format the file should be in.</p>            
          <input type="file" name="myfile" id="form-control"
                 onChange={fileChanged} />
          <input type="submit" value="Upload" id="submit"/>
          
          {badfile? <p>This file type is not supported</p> : <></>}          
        </form>
      }
    </>
  );   
}